import React from "react";
import "../css/LoadingOverlay.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const LoadingOverlay = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-spinner-container">
        <FontAwesomeIcon icon={faSpinner} spin size="9x" />
      </div>
    </div>
  );
};

export default LoadingOverlay;
